import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { StripedDataGrid } from '../../factories/DataGrid';
import { PayloadParserContext } from '../PayloadParserContext';
const generateDataGridProps = (headings, readings) => {
    const dataGridProps = {
        columns: headings,
        rows: readings,
        rowHeight: 15,
        autoHeight: true,
        onProcessRowUpdateError: e => {
            console.log(e.message);
        },
        getRowClassName: params => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
    };
    return dataGridProps;
};
const PayloadParserReadings = () => {
    const { readings } = useContext(PayloadParserContext);
    const [{ contextCustomer }] = useContext(AppMainViewContext);
    const headings = useMemo(() => {
        if (readings && readings.length > 0) {
            const keys = Object.keys(readings[0]);
            return keys.map(key => {
                return {
                    headerName: key,
                    field: key,
                    width: 150,
                };
            });
        }
        return [];
    }, [readings]);
    return (_jsx("div", { children: contextCustomer && readings && headings && (_jsx(StripedDataGrid, { ...generateDataGridProps(headings, readings) }, 'ObservationCardGrid')) }));
};
export default PayloadParserReadings;
